export default "__VITE_ASSET__CsWdT6cM__"